<template>
  <v-footer
    class="py-0"
    dark
    height="auto"
  >
    <v-container mx-auto class="py-1">
      <v-layout wrap>
        <v-flex xs1>
          <base-btn
            v-for="(item, i) in footer_links"
            :key="i"
            :href="item.href"
            class="ml-0 mr-3"
            color="primary"
            square
            target="_blank"
          >
            <v-icon v-text="item.icon" />
          </base-btn>
        </v-flex>
        <v-flex xs7 class="hidden-md-and-down" style="padding-top: 6px;">
          {{about.recipient_full}}<br>
          {{about.recipient_info}}
        </v-flex>
        <v-flex xs3 class="hidden-sm-and-down" style="padding-top: 6px;">
          Тел.: {{about.boss_phone}}<br>
          E-Mail: {{about.boss_email}}
        </v-flex>
        <v-spacer />
        <base-btn
          class="mr-0"
          square
          title="Go to top"
          @click="$vuetify.goTo(0)"
        >
          <v-icon>mdi-chevron-up</v-icon>
        </base-btn>
      </v-layout>
    </v-container>
  </v-footer>
</template>

<script>
  import axios from 'axios'

  export default {
    data: function() {
      return {
        about: {},
        footer_links: []
      }
    },
    mounted () {
      axios.get('/static/data/about.json')
        .then(response => {
          this.about = response.data
          this.footer_links = [{
            href: this.about.vk_link,
            icon: 'mdi-vk'
          }]
        }).catch(error => {
          console.log(error)
        })
    }
  }
</script>
